import { paramAttachment, paramRepeater, paramXPathSrc } from '../constants/parameterNames';
import { typeXPath } from '../constants/parameterTypes';
import { getParamValue } from '../helpers/parameter.accessors';

const description = "Enables multi-file drop support for certain form fields.";

const requiredParameters = [
    {
        name: paramRepeater,
        description: "XPath to the repeating group on which to enable multi-file drop",
        type: typeXPath
    }
];

const optionalParameters = [
    {
        name: paramAttachment,
        description: `XPath, relative to /${paramRepeater}, to the location of the attachment field. If unspecified, the path indicated by /${paramRepeater} is assumed to be the field itself.`,
        type: typeXPath,
        relativeTo: paramRepeater
    },
    {
        name: paramXPathSrc,
        description: `A direct XPath to the location of the repeating group indicated by /${paramRepeater}, but without any filters or other complex XPath constructions. This may be needed if /${paramRepeater} involves filters or other complex syntax.`,
        type: typeXPath
    }
];

const execute = ({ parameters, fileDrop }) => {
    fileDrop.registerMultiDrop({
        // The file drop handler has support for specifying a DS name, but this is irrelevant right now
        // because it's not possible to create editable file controls from 2DSes
        repeaterPath: getParamValue(parameters, paramRepeater),
        attachmentPath: getParamValue(parameters, paramAttachment, '.'),
        xpathsrc: getParamValue(parameters, paramXPathSrc)
    });

    return '';
};

const RegisterMultiDrop = {
    description,
    requiredParameters,
    optionalParameters,
    execute,
};

export default RegisterMultiDrop;